/**
 * Decides what Grant Access should do once a service's existing auth/sync
 * state is known. Shared by ocFlow and drFlow (useServiceWizard.js) — both
 * now implement the same policy-driven decision, just with different
 * resulting actions (microsoftAuth vs gcchAuth).
 *
 * @param {object} params
 * @param {boolean} params.graphAuth - already authenticated via Graph API
 * @param {boolean} params.userSync - already syncing users
 * @param {boolean} [params.authDisabled] - auth isn't allowed for this service's policy (ocFlow only)
 * @param {boolean} params.syncForced - the company's selectiveSyncPolicy is REQUIRED (2)
 * @param {*} params.serviceAuth - the existing app auth record for this company/platform, if any
 * @returns {'start' | 'selectiveSync' | 'auth'}
 */
export default function resolveGrantAccessAction({
    graphAuth,
    userSync,
    authDisabled = false,
    syncForced,
    serviceAuth,
}) {
    // Already fully synced/authenticated — nothing to grant.
    if (graphAuth && userSync) return 'start';
    // Auth isn't allowed at all for this service's policy — nothing to
    // grant either way.
    if (authDisabled) return 'start';
    // The only case that shows the Selective Sync form: sync is REQUIRED
    // and nothing is configured yet for this company/platform.
    if (syncForced && !serviceAuth) return 'selectiveSync';
    // Everything else — policy doesn't force sync, or an app auth already
    // exists (any status) — Grant Access prioritises msloginlink.
    return 'auth';
}
